



























import { Component, Vue } from 'vue-property-decorator'
import Moment from 'moment'
import ApiLegacy from '@finx/web-repository/src/apis/Legacy/Legacy'
import StoreRelatorios from '@/store/Relatorios'

@Component

export default class ViewRelatorioPdf extends Vue {
  dataInicial: String = ''
  dataFinal: String = ''
  idFontePagadora: String = ''
  relatorio: Object = {}
  today: String = ''

  data() {
    return {
      dataInicial: this.$route.params.dataInicial || '2019-01-01',
      dataFinal: this.$route.params.dataFinal || '2019-06-06',
      idFontePagadora: this.$route.params.idFontePagadora,
      today: null,
      relatorio: {},
    }
  }

  get prestador(): any {
    return StoreRelatorios.getters.PRESTADOR
  }

  mounted() {
    this.today = Moment(new Date()).format('DD/MM/YYYY')

    this.getPdfData()
  }

  async getPdfData() {
    let prestadorId = null

    const hasPrestador = Object.keys(this.prestador).length > 0
    if (hasPrestador) prestadorId = this.prestador.id

    const relatorio = await ApiLegacy.Reports.getPdfData(this.dataInicial, this.dataFinal, this.idFontePagadora, prestadorId)
    this.relatorio = relatorio.data.data
  }

  print() {
    window.print()
  }
}

